module.exports = __webpack_public_path__ + "img/ico-09.525951d3.png";